import { type FC } from 'react'

import { useFormContext } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import { useMessageEditor } from './message-editor-context'
import type { MessageFormValues } from './schema'

interface Props {
  onClose: () => void
  isLoading: boolean
}

export const MessageActionButtons: FC<Props> = ({ onClose, isLoading }) => {
  const { watch } = useFormContext<MessageFormValues>()
  const { isEmpty } = useMessageEditor()
  const medias = watch('medias')

  return (
    <Dialog.Footer className="gap-[24px]">
      <Button
        type="button"
        variant="outline"
        className="flex-1"
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        className="flex flex-1 items-center justify-center gap-2"
        disabled={isEmpty && !medias?.length}
        isLoading={isLoading}
      >
        Save Message
      </Button>
    </Dialog.Footer>
  )
}
